export default __webpack_public_path__ + "static/media/popup_4.ca732ec9.jpeg";